// Empty default = same origin. Never default to localhost: that is
// "the visitor's own machine" once built, so the deployed site could
// never reach a backend.
export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL ?? "";
export const API = `${BACKEND_URL}/api/v1`;
